<template>
    <div class="search-box">
        <div  class="home-search" :class="{'home-search1':($store.state.home.scrollState>0 || $store.state.home.navIndex===2)}" >
            <input 
            placeholder="請輸入關鍵字搜索考試"
            ref="search"
            v-model="search"
            type="text" 
            @keyup.enter='searchData'
            @focus="searchState=true"
            @blur="inputBlur"
            @keydown.down="searchDown"
            @keydown.up="searchDown"
              >
            <button class="el-icon-search p-pointer" @click="searchData"></button>
        </div>
        <!-- <ul v-show="(searchlists.length>0 && searchState)">
            <li class="p-pointer" v-for="(item,index) in searchlists" :key="index" @click="$router.push({path:'/home/lessons/study',query:{id:item.id}})">
                <div v-html="showDate(item.name)"></div>
            </li>
        </ul> -->
    </div>
</template>
<script>
export default {
    data(){
        return {
            focus:false,
            search:'',
            searchState:true,
        }
    },
    computed:{
        
    },
    methods:{
        searchData(){
            // this.$refs.search.blur();
            this.$emit('search',this.search)
        },
        inputBlur(){
            setTimeout(()=>{this.searchState=false},200)
        },
        // 没时间搞
        searchDown(){
        }
    }
}
</script>

<style lang="less" scoped>
.search-box{
    position: relative;
    >ul{
        color: #333333;
        position: absolute;
        top: 44px;
        width:750px;
        // padding: 0 30px;
        box-sizing: border-box;
        background:rgba(255,255,255,1);
        box-shadow:0px 3px 10px rgba(51,51,51,0.3);
        li{
            padding: 0 30px;
            
            >div{
                padding: 10px 0;
                border-bottom: 1px solid #EEEEEE;
            }
            &:hover{
                background: rgba(0, 0, 0, .1)
            }
        }
    }
}
.home-search{
    width: 417px;
    height: 37px;
    overflow: hidden;
    border-radius: 20px;
    position: relative;
    input{
        height: 100%;
        border: 0;
        width: 360px;
        font-size:12px;
        padding-left: 15px;
        box-sizing: border-box;
        float: left;
        background:rgba(255,255,255,.3);
        outline:none;
    }
    button{
        float: left;
        border: 0;
        height: 100%;
        width: 57px;
        color: #4D8EF6;
        background:rgba(255,255,255,0.8);
        outline:none;
    }
    input::-webkit-input-placeholder{
        color:#ffffff;
        opacity:.5;
    }
    input::-moz-placeholder{   /* Mozilla Firefox 19+ */
        color:#ffffff;
        opacity:.5;
    }
    input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
        color:#ffffff;
        opacity:.5;
    }
    input:-ms-input-placeholder{  /* Internet Explorer 10-11 */ 
        color:#ffffff;
        opacity:.5;
    }
}
.home-search1{
    input{
        background:rgba(206,206,217,.3);
    }
    button{
        background: #4D8EF6;
        color: #ffffff;
    }
    input::-webkit-input-placeholder{
        color:#000000;
        opacity:.5;
    }
    input::-moz-placeholder{   /* Mozilla Firefox 19+ */
        color:#000000;
        opacity:.5;
    }
    input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
        color:#000000;
        opacity:.5;
    }
    input:-ms-input-placeholder{  /* Internet Explorer 10-11 */ 
        color:#000000;
        opacity:.5;
    }
}
</style>
